import React, { useState } from "react"
import { Button, CardText, Col, Row } from "reactstrap"

import DBFileBrowser from "../../../framework/components/DBFileBrowser"
import DPImage from "../../../framework/components/DPImage"
import DPImagePop from 'framework/components/DPImagePop'
import WebcamCapture from "framework/components/WebcamCapture"

const ProductImageContent = ({ ShowPreview, imagesrc, Disabled, imgvalue, RemoveImage, setPicture }) => {
  const [isOpen, SetIsOpen] = useState(false)
  const showPop = () => {
    SetIsOpen(!isOpen)
  }
  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                <Col sm={12} md={3} className="mb-4-sm">
                  <DPImage
                    labelText={imagesrc}
                    onClick={showPop}
                    style={{ cursor: 'pointer' }}
                  ></DPImage>
                  <DPImagePop
                    toggle={showPop}
                    isOpen={isOpen}
                    width={'400px'}
                    height={'400px'}
                    ImgSrc={imagesrc}
                  />
                  <DBFileBrowser
                    accept="image/*"
                    rowClass="mb-4-sm"
                    labelText="Upload"
                    showPrewiew={ShowPreview}
                    disable={Disabled}
                    value={""}
                  ></DBFileBrowser>
                </Col>
                <WebcamCapture
                  setImage={setPicture}
                  image={imagesrc}
                  disable={Disabled}
                />
              </Row>
              <Row className="mt-1">
                <Col sm={12} md={6} className="mb-4-sm">
                  <Button
                    color="danger"
                    className="mr-1"
                    disabled={Disabled}
                    onClick={RemoveImage}
                    size="sm"
                  >
                    Remove Image
                  </Button>
                </Col>
              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default ProductImageContent
